import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export default function ContactForm() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_u4he08e', 'template_02710dm', form.current, {
        publicKey: 'dp6P-5H6DTaAEm6kM',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          window.location.reload();
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <div class="flex flex-col">
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="text" name="name" placeholder="YOUR NAME (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="text" name="partner_name" placeholder="PARTNER'S NAME"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="email" name="email" placeholder="EMAIL (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="tel" name="phone_number" placeholder="PHONE NUMBER (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="text" name="event" placeholder="EVENT (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="text" name="location" placeholder="VENUE NAME / LOCATION (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="date" name="date" placeholder="DATE (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="number" name="guest_count" placeholder="ESTIMATED GUEST COUNT (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" type="number" name="budget" placeholder="ESTIMATED EVENT BUDGET"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="text" name="package" placeholder="WHAT PACKAGE ARE YOU INTERESTED IN (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="text" name="hear" placeholder="HOW DID YOU HEAR ABOUT US (required)"/>
        <input class="placeholder-primary text-xs p-2.5 border-solid border-b-[1.5px] border-primary" required="required" type="text" name="more" placeholder="TELL US MORE ABOUT YOUR EVENT"/>
      </div>
      <div class="w-full flex justify-center mt-6">
        <button type="submit" class="inline-flex mx-auto bg-button py-4 px-8 rounded-full">
          <span class="uppercase text-primary text-xs">
            Submit Inquiry
          </span>
        </button>
      </div>
    </form>
  );
};